import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { AuthService } from '../services/auth.service';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const excludedUrls: string[] = [];
  if (environment.s3Url) excludedUrls.push(environment.s3Url);
  if (environment.s3Url2) excludedUrls.push(environment.s3Url2);
  if (environment.s3Url3) excludedUrls.push(environment.s3Url3);
  const shouldSkipAuth = excludedUrls.some(url => req.url.includes(url));

  if (shouldSkipAuth) {
    return next(req);
  }

  let isRefreshing = false;
  const refreshTokenSubject = new BehaviorSubject<string | null>(null);

  function handle401Error(request: HttpRequest<any>): Observable<HttpEvent<any>> {
    if (!isRefreshing) {
      isRefreshing = true;
      refreshTokenSubject.next(null);
      return authService.refreshToken().pipe(
        switchMap((token: string) => {
          isRefreshing = false;
          refreshTokenSubject.next(token);
          const authReq = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              // ...(request.headers.get('Content-Type') ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'multipart/form-data' })
            }
          });
          return next(authReq);
        }),
        catchError(err => {
          isRefreshing = false;
          authService.logout();
          return throwError(() => err);
        })
      );
    } else {
      return refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          const authReq = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              // ...(request.headers.get('Content-Type') ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'multipart/form-data' })
            }
          });
          return next(authReq);
        })
      );
    }
  }

  return authService.getAccessToken().pipe(
    switchMap(token => {
      let authReq = req;
      if (token) {
        authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            // ...(req.headers.get('content-Type') ? { 'Content-Type': req.headers.get('content-Type')! } : { 'Content-Type': 'application/json' })
          }
        });
      }
      return next(authReq);
    }),
    catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return handle401Error(req);
      }
      return throwError(() => error);
    })
  );
};